export default __webpack_public_path__ + "static/media/son_actif.33ec7e67.svg";